import React from 'react';

export const SvgSentimentDissatisfied = props => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 12C2 6.48 6.47 2 11.99 2 17.52 2 22 6.48 22 12s-4.48 10-10.01 10C6.47 22 2 17.52 2 12zm6.5-4a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm7 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm-4.65-3.42C8.37 14.97 10.1 14 12 14c1.9 0 3.63.96 4.66 2.58.22.35.11.81-.24 1.03a.83.83 0 01-.4.11c-.25 0-.5-.12-.64-.35-.74-1.18-2-1.88-3.38-1.88s-2.64.7-3.38 1.88a.747.747 0 11-1.27-.79z"
      fill="currentColor"
    />
  </svg>
);
